module.exports = __webpack_public_path__ + "img/red-delete-bin.5b00688f.svg";